export const GET_DEALERINFO_API_REQUEST = "GET_DEALERINFO_API_REQUEST";
export const GET_DEALERINFO_API_SUCCESS = "GET_DEALERINFO_API_SUCCESS";
export const GET_DEALERINFO_API_ERROR = "GET_DEALERINFO_API_ERROR";